import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const UserIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
    className={makeClassName('UserIcon', className)}
  >
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
    ></path>
    <circle
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      cx="12"
      cy="7"
      r="4"
    ></circle>
  </svg>
);

export default UserIcon;
